import { makeAutoObservable } from 'mobx'
import { RootStore } from './RootStore'

export class TimerStore {
  rootStore: RootStore
  timerStartedAt: string | null = null

  constructor(rootStore: RootStore) {
    makeAutoObservable(this)
    this.rootStore = rootStore
  }

  startTimer() {
    // If the timer is already running, do nothing.
    if (this.timerStartedAt) return

    this.timerStartedAt = new Date().toISOString()
  }

  resetTimer() {
    this.timerStartedAt = null
  }

  fetchAndResetTimer() {
    const startedAt = this.timerStartedAt
    this.resetTimer()
    return startedAt
  }
}
